interface SuggestionButtonsProps {
  suggestions: string[];
  onSelect: (text: string) => void;
  disabled?: boolean;
}

export default function SuggestionButtons({
  suggestions,
  onSelect,
  disabled,
}: SuggestionButtonsProps) {
  if (suggestions.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 mt-3">
      {suggestions.map(text => (
        <button
          key={text}
          onClick={() => onSelect(text)}
          disabled={disabled}
          className="rounded-full border border-primary/20 bg-primary/5 px-4 py-2 text-sm text-foreground hover:bg-primary/10 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {text}
        </button>
      ))}
    </div>
  );
}
